<template>
  <milestone-wrapper :subscription-period-id="subscriptionPeriodId" :data="data" :meta="meta">
    <template slot="content-completed">
      <EmailBatchDisplay v-if="content && content.emails" :email="content.emails[0]" class="q-mt-md" />

      <GridTable v-if="items" :columns="columns" :rows="items" class="col-12">
        <template #row="{row}">
          <GridTableCell>{{ row.name }}</GridTableCell>
          <GridTableCell>{{ getPeriod(row) }}</GridTableCell>
        </template>
      </GridTable>
    </template>
  </milestone-wrapper>
</template>

<script>
import MilestoneMixin from '@/mixins/milestone.mixin'
// Libraries
import { get } from 'lodash'
// Components
import MilestoneWrapper from '@/components/milestones/MilestoneWrapper'
import EmailBatchDisplay from '@/components/lm-blocks/EmailBatchDisplay'
import GridTable from '@/reusable/grid-table/GridTable'
import GridTableCell from '@/reusable/grid-table/GridTableCell'

export default {
  components: {
    MilestoneWrapper,
    EmailBatchDisplay,
    GridTable,
    GridTableCell
  },

  mixins: [MilestoneMixin],

  props: {
    data: {
      type: Object,
      required: true
    },
    meta: {
      type: Object,
      required: true
    },
    subscriptionPeriodId: {
      type: Number,
      required: true
    }
  },

  computed: {
    items() {
      return get(this, 'content.items')
    },

    columns() {
      return [
        { label: 'Subscriptions included', width: '1fr' },
        { label: 'Period', width: '1fr' }
      ]
    }
  }
}
</script>
